import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import type { AxiosError } from 'axios';
import { useAuthUser } from '../hooks/useAuthUser';
import { useAuthStore } from '../store/authStore';

// super_admin verwaltet RentalHub nicht mehr selbst (analog TireVault, siehe
// Memory project_superadmin_portal_migration) — raus aus RentalHub, rein ins Portal.
const PORTAL_ADMIN_URL = 'https://werkstatt-connect.de/admin';

export function ProtectedRoute() {
  const { data: user, isLoading, isError, error } = useAuthUser();
  const setUser = useAuthStore((state) => state.setUser);
  const clearUser = useAuthStore((state) => state.clearUser);

  // authStore synchron halten, fuer Komponenten, die direkt darauf zugreifen.
  // Die Query selbst bleibt die autoritative Quelle.
  useEffect(() => {
    if (user) {
      setUser(user);
    } else if (isError) {
      clearUser();
    }
  }, [user, isError, setUser, clearUser]);

  // Spinner nur beim initialen Laden (kein gecachtes Ergebnis vorhanden)
  if (isLoading && !user) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Nur bei echtem Auth-Fehler (401) weiterleiten — 403 loest keinen Logout aus
  const isAuthError = isError && (error as AxiosError)?.response?.status === 401;
  if (isAuthError || !user) {
    return <Navigate to="/login" replace />;
  }

  if (user.role === 'super_admin') {
    window.location.href = PORTAL_ADMIN_URL;
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  return <Outlet />;
}
